import { SquareMultiplierEnum } from "./Enums";
import { PointValues } from "./PointValues";
import Position from "./Position";
import { mulberry32, xmur3 } from "./Random";
import SquareContents from "./SquareContents";
import Word from "./Word";
import dictionary from './dictionary.json';
import wordbank from './wordbank.json';
import { BOARD_SIZE, WORD_LIST_LENGTH } from "./Constants";

let characterArray: string[][] = [];
let fillerArray: string[][] = [];
let words: Word[] = [];

let date = new Date();

let seed = xmur3(`${date.getFullYear()}-${date.getMonth()}-${date.getDay()}`);
let rand = mulberry32(seed());


function generateContents() {
    characterArray = [];
    fillerArray = [];
    words = [];

    for (var i = 0; i < BOARD_SIZE; i++) {
        fillerArray.push([]);
        characterArray.push([]);
        for (var j = 0; j < BOARD_SIZE; j++) {
            let c = String.fromCharCode(Math.floor(rand() * 26) + 65);
            fillerArray[i].push(c);
            characterArray[i].push('');
        }
    }

    for (var i = 0; i < WORD_LIST_LENGTH; i++) {
        let tryCount = 0;
        let found = false;
        while (tryCount++ < 1000 && !found) {
            found = tryFindWord();
        }
    }
}

function initializeContents() {
    for (var i = 0; i < BOARD_SIZE; i++) {
        fillerArray.push([]);
        characterArray.push([]);
        for (var j = 0; j < BOARD_SIZE; j++) {
            let c = String.fromCharCode(Math.floor(rand() * 26) + 65);
            fillerArray[i].push(c);
            characterArray[i].push('');
        }
    }

    for (var i = 0; i < WORD_LIST_LENGTH; i++) {
        let tryCount = 0;
        let found = false;
        while (tryCount++ < 1000 && !found) {
            found = tryFindWord();
        }
    }

}

function resetCharacterArray() {
    for (var i = 0; i < BOARD_SIZE; i++) {
        for (var j = 0; j < BOARD_SIZE; j++) {
            characterArray[i][j] = '';
        }
    }
    words.forEach(word => {
        let p = new Position(word.startPosition.x, word.startPosition.y);
        for (var i = 0; i < word.word.length; i++) {
            characterArray[p.x][p.y] = word.word.charAt(i);
            p.x += word.dirX;
            p.y += word.dirY;
        }
    })
}

function incrementContents() {
    characterArray.pop();
    characterArray.splice(0, 0, []);
    fillerArray.pop();
    fillerArray.splice(0, 0, []);
    for (var j = 0; j < BOARD_SIZE; j++) {
        let c = String.fromCharCode(Math.floor(rand() * 26) + 65);
        fillerArray[0].push(c);
        characterArray[0].push('');
    }
    for (var i = words.length - 1; i >= 0; i--) {
        words[i].startPosition.x++;
        if (words[i].startPosition.x >= BOARD_SIZE || words[i].GetEndPosition().x >= BOARD_SIZE) {
            words.splice(i, 1);
        }
    }
    resetCharacterArray();
    for (var i = words.length; i < WORD_LIST_LENGTH; i++) {
        let tryCount = 0;
        let found = false;
        while (tryCount++ < 1000 && !found) {
            found = tryFindWord();
        }
    }
}

function tryFindWord(): boolean {
    let word = wordbank[Math.floor(rand() * wordbank.length)].toUpperCase();
    let tryCount = 0;
    while (tryCount++ < 1000) {
        let startX = Math.floor(rand() * BOARD_SIZE);
        let startY = Math.floor(rand() * BOARD_SIZE);
        let dirX = 0;
        let dirY = 0;
        while (dirX === 0 && dirY === 0) {
            dirX = Math.floor(rand() * 3) - 1
            dirY = Math.floor(rand() * 3) - 1;
        }
        let valid = true;
        let x = startX;
        let y = startY;
        for (var i = 0; i < word.length && valid; i++) {
            valid =
                x >= 0 && x < BOARD_SIZE && y >= 0 && y < BOARD_SIZE &&
                (characterArray[x][y] === '' || word.charAt(i) === characterArray[x][y]);
            x += dirX;
            y += dirY;
            if (!valid) {
                break;
            }
        }
        if (valid) {
            words.push(new Word(word, new Position(startX, startY), dirX, dirY));
            for (var i = 0; i < word.length; i++) {
                fillerArray[startX][startY] = characterArray[startX][startY] = word.charAt(i);
                startX += dirX;
                startY += dirY;
            }
            return true;
        }
    }
    return false;
}

function getRandomPositionInWord(): Position {
    let position = new Position(0, 0);
    const word = words[Math.floor(rand() * words.length)];
    const length = Math.floor(rand() * word.word.length);
    position.x = word.startPosition.x + (word.dirX * length);
    position.y = word.startPosition.y + (word.dirY * length);
    return position;
}

function getContents(): { contents: SquareContents[][], words: Word[] } {
    let result: SquareContents[][] = [];

    for (var i = 0; i < BOARD_SIZE; i++) {
        result.push([]);
        for (var j = 0; j < BOARD_SIZE; j++) {
            let c = characterArray[i][j] !== '' ? characterArray[i][j] : fillerArray[i][j];
            result[i].push(new SquareContents(
                c, (PointValues as any)[c]));
        }
    }

    for (var i = 0; i < 3; i++) {
        let position = getRandomPositionInWord();
        let multiplier = SquareMultiplierEnum.DoubleLetter;
        let randMultiplier = Math.floor(rand() * 6)
        switch (randMultiplier) {
            case 2:
            case 3:
                multiplier = SquareMultiplierEnum.TripleLetter;
                break;
            case 4:
                multiplier = SquareMultiplierEnum.DoubleWord;
                break;
            case 5:
                multiplier = SquareMultiplierEnum.TripleWord;
                break;

        }
        result[position.x][position.y].multiplier = multiplier;
    }

    return { contents: result, words: words };

    const max = BOARD_SIZE - 1;
    const middle = Math.floor(BOARD_SIZE / 2);



    result[middle][1].multiplier = result[1][middle].multiplier =
        result[max - 1][middle].multiplier = result[middle][max - 1].multiplier = SquareMultiplierEnum.TripleLetter;

    result[middle - 1][0].multiplier = result[middle + 1][0].multiplier =
        result[0][middle - 1].multiplier = result[0][middle + 1].multiplier =
        result[max][middle - 1].multiplier = result[max][middle + 1].multiplier =
        result[middle - 1][max].multiplier = result[middle + 1][max].multiplier =
        result[middle][middle].multiplier = SquareMultiplierEnum.DoubleLetter;

    for (var i = 0; i < middle; i++) {
        result[i][i].multiplier = result[i][max - i].multiplier =
            result[max - i][i].multiplier = result[max - i][max - i].multiplier = i === 0 ? SquareMultiplierEnum.TripleWord : SquareMultiplierEnum.DoubleWord;

    }

    return { contents: result, words: words };
}

function isWordSearch(word: string, start: number, end: number): boolean {

    if (start > end) {
        return false;
    }

    let mid = Math.floor((start + end) / 2);

    if (dictionary[mid] === word) {
        return true;
    }

    if (dictionary[mid] > word) {
        return isWordSearch(word, start, mid - 1);
    }
    else {
        return isWordSearch(word, mid + 1, end);
    }
}

export function GetInitialContents(): { contents: SquareContents[][], words: Word[] } {
    if (characterArray.length === 0) {
        initializeContents();
    }
    return getContents();
}

export function GetNextContents(): { contents: SquareContents[][], words: Word[] } {
    incrementContents();
    return getContents();
}

export function GetContents(): { contents: SquareContents[][], words: Word[] } {
    generateContents();
    return getContents();
}
export function RemoveWord(index: number) {
    let word = words.splice(index, 1)[0];
}

export function IsWord(word: string): boolean {
    return isWordSearch(word, 0, dictionary.length - 1);
}